<template lang="pug">
vm-tabs
  vm-tab(vm-label='Español')
    vm-row(vm-justify="center", vm-align="center", vm-w=12)
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("campaigns.title")' v-model="form.data.es.title" minLength="2" :label='$t("campaigns.title")')
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar descripción
            vm-switch(v-model="form.data.es.description.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.es.description.visible")
        b-form-group
          label {{ $t("campaigns.description") }}
          ckeditor(v-model="form.data.es.description.text" :editor="editor.component" :config="editor.editorConfig")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar beneficios
            vm-switch(v-model="form.data.es.benefits.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.es.benefits.visible")
        label {{ $t("campaigns.benefits") }} (presionar ENTER para agregar)
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.es.benefits.visible")
        b-form-group
          vm-input(v-model="benefit" minLength="2" @keyup.enter="addBenefit('es')")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.es.benefits.length && form.data.es.benefits.visible")
        label Beneficios agregados
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        vm-row(vm-justify="space-around", vm-align="center", vm-w=12)
          vm-col.gutters(vm-justify="center", vm-align="center", vm-w=4 v-for="(value, index) in form.data.es.benefits.values" class="benefit")
            span( class="benefit__wrapper") {{ value.text }}
            vm-button(icon="trash-outline" color="danger" size="small" class="benefit__wrapper__delete" @click="deleteBenefit(index, 'es')")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar texto adicional
            vm-switch(v-model="form.data.es.aditionalText.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.es.aditionalText.visible")
        b-form-group
          label Texto adicional
          ckeditor(v-model="form.data.es.aditionalText.text" :editor="editor.component" :config="editor.editorConfig")
  vm-tab(vm-label='Ingles')
    vm-row(vm-justify="center", vm-align="center", vm-w=12)
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("campaigns.title")' v-model="form.data.en.title" minLength="2" :label='$t("campaigns.title")')
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar descripción
            vm-switch(v-model="form.data.en.description.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.en.description.visible")
        b-form-group
          label {{ $t("campaigns.description") }}
          ckeditor(v-model="form.data.en.description.text" :editor="editor.component" :config="editor.editorConfig")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar beneficios
            vm-switch(v-model="form.data.en.benefits.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.en.benefits.visible")
        label {{ $t("campaigns.benefits") }} (presionar ENTER para agregar)
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.en.benefits.visible")
        b-form-group
          vm-input(v-model="benefit" minLength="2" @keyup.enter="addBenefit('en')")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.en.benefits.length && form.data.en.benefits.visible")
        label Beneficios agregados
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        vm-row(vm-justify="space-around", vm-align="center", vm-w=12)
          vm-col.gutters(vm-justify="center", vm-align="center", vm-w=4 v-for="(value, index) in form.data.en.benefits.values" class="benefit")
            span( class="benefit__wrapper") {{ value.text }}
            vm-button(icon="trash-outline" color="danger" size="small" class="benefit__wrapper__delete" @click="deleteBenefit(index, 'en')")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          label Mostrar texto adicional
            vm-switch(v-model="form.data.en.aditionalText.visible")
      vm-col.gutters(vm-justify="center", vm-align="center", vm-w=12 v-if="form.data.en.aditionalText.visible")
        b-form-group
          label Texto adicional
          ckeditor(v-model="form.data.en.aditionalText.text" :editor="editor.component" :config="editor.editorConfig")
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'VDefaultTemplate',
  components: {
    ClassicEditor
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    editor: {
      component: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        placeholder: 'Descripción de la solución',
        toolbar: [ 'bold', 'italic', '|', 'link', '|' ]
      }
    },
    benefit: null
  }),
  methods: {
    addBenefit (lang) {
      if (this.benefit) {
        this.form.data[lang].benefits.values.push({ text: this.benefit })
        this.benefit = null
      }
    },
    deleteBenefit (index, lang) {
      this.form.data[lang].benefits.values.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.benefit {
  margin-bottom: 20px;
  display: flex;
  position: relative;
  &__wrapper {
    background-color: rgba($color: var(--gray), $alpha: 1.0);
    border-radius: 0.5em;
    text-align: center;
    padding: 10px 20px;
    display: block;
    width: 100%;
    &__delete {
      position: absolute;
      top: 0;
      right: 10px;
    }
  }
}
</style>
